import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const whatsappNumber = "+919974056700"; // Kunjvihari Impex WhatsApp number
  const defaultMessage = "Hello! I'm interested in your fabric products. Could you please provide more information?";

  const quickMessages = [
    "I need a quote for wholesale fabric",
    "What fabrics do you have available?",
    "Can I get fabric samples?",
    "What are your wholesale rates?",
    "What\'s your minimum order quantity?"
  ];

  const handleSendMessage = (customMessage = null) => {
    const messageToSend = customMessage || message || defaultMessage;
    const encodedMessage = encodeURIComponent(messageToSend);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
    setIsOpen(false);
    setMessage('');
  };

  const handleQuickMessage = (quickMessage) => {
    handleSendMessage(quickMessage);
  };

  return (
    <>
      {/* WhatsApp Chat Widget */}
      {isOpen && (
        <div className="fixed bottom-20 sm:bottom-24 right-2 sm:right-4 w-[calc(100vw-1rem)] sm:w-80 max-w-sm bg-background border border-border rounded-2xl shadow-heritage z-50 animate-slide-up">
          {/* Header */}
          <div className="bg-gradient-to-r from-green-500 to-green-600 text-white p-3 sm:p-4 rounded-t-2xl">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2 sm:space-x-3">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white/20 rounded-full flex items-center justify-center">
                  <Icon name="MessageCircle" size={18} />
                </div>
                <div>
                  <div className="font-semibold text-sm sm:text-base">Kunjvihari Impex</div>
                  <div className="text-xs opacity-90">Typically replies instantly</div>
                </div>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-white/80 hover:text-white transition-colors duration-200"
              >
                <Icon name="X" size={20} />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="p-3 sm:p-4 max-h-[60vh] overflow-y-auto">
            {/* Welcome Message */}
            <div className="bg-surface rounded-lg p-2 sm:p-3 mb-3 sm:mb-4">
              <div className="text-xs sm:text-sm text-text-primary mb-1 sm:mb-2">
                👋 Hello! Welcome to Kunjvihari Impex
              </div>
              <div className="text-xs sm:text-sm text-text-secondary">
                How can we help you with your fabric requirements today?
              </div>
            </div>

            {/* Quick Messages */}
            <div className="space-y-2 mb-3 sm:mb-4">
              <div className="text-xs text-text-secondary mb-2">Quick messages:</div>
              {quickMessages?.map((quickMessage, index) => (
                <button
                  key={index}
                  onClick={() => handleQuickMessage(quickMessage)}
                  className="w-full text-left p-2 text-xs sm:text-sm bg-surface hover:bg-muted rounded-lg transition-colors duration-200 border border-border"
                >
                  {quickMessage}
                </button>
              ))}
            </div>

            {/* Custom Message Input */}
            <div className="space-y-2 sm:space-y-3">
              <textarea
                value={message}
                onChange={(e) => setMessage(e?.target?.value)}
                placeholder="Type your message here..."
                className="w-full p-2 sm:p-3 text-xs sm:text-sm border border-border rounded-lg resize-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                rows={3}
              />
              <button
                onClick={() => handleSendMessage()}
                className="w-full bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded-lg flex items-center justify-center space-x-2 transition-colors duration-200 text-sm sm:text-base"
              >
                <Icon name="Send" size={16} />
                <span>Send Message</span>
              </button>
            </div>
          </div>
        </div>
      )}
      {/* WhatsApp Float Button */}
      <div className="fixed bottom-4 right-4 z-50">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-12 h-12 sm:w-14 sm:h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-300 hover:scale-110 group"
          aria-label="Open WhatsApp chat"
        >
          {isOpen ? (
            <Icon name="X" size={20} />
          ) : (
            <Icon name="MessageCircle" size={20} className="group-hover:animate-bounce" />
          )}
        </button>

        {/* Notification Badge */}
        {!isOpen && (
          <div className="absolute -top-1 -right-1 w-4 h-4 sm:w-5 sm:h-5 bg-red-500 text-white text-[10px] sm:text-xs rounded-full flex items-center justify-center animate-pulse">
            1
          </div>
        )}
      </div>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/20 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default WhatsAppWidget;